import React from 'react';
import PropTypes from 'prop-types';
import siteStructure from '../../../data/siteStructure';
import { truncateString } from '../../../utils/stringConversion';
import planName from '../../../utils/planStringConversion';
import SpinLoader from '../Loaders/SpinLoader';
import IconWithText from '../Icons/IconWithText';

const AccountMenu = ({ loggedInUser, billingEnabled }) => {
  const linkClass = `link link--secondary fw-medium`;

  return (
    <div className="account-menu">
      <div className="account-menu__overview bg-grey--lightest border-bottom-1 border-bottom-color-grey--light overflow-hidden p-a-3 m-b-5">
        {!loggedInUser.id ? (
          <SpinLoader black positionStatic />
        ) : (
          <div className="d-flex align-items-center">
            <div className="m-r-3 overflow-hidden">
              <span className="d-block like-h5 fw-bold m-b-0">{truncateString(loggedInUser.full_name, 15)}</span>
              <span className="d-block color-grey">{truncateString(loggedInUser.email_address, 20)}</span>
              <a href={`/user/${loggedInUser.id}`} className="link link--tertiary fw-medium">View your profile</a>
            </div>
            <div className="m-l-auto">
              <a href="/account/plan" className="btn btn--s text-uppercase letter-spacing-s">{planName(loggedInUser.computed_access)}</a>
            </div>
          </div>
        )}
      </div>

      <div className="m-b-5 p-x-3">
        <h2 className="like-p fw-medium text-uppercase letter-spacing-s color-grey">Your Account</h2>
        <ul className="faux-list-new">
          {siteStructure
            .filter(item => item.parentId === `account`)
            .filter((item) => {
              // We do not equals to as billingEnabled could be undefined
              if (billingEnabled !== true) {
                switch (item.id) {
                  case `plan`:
                  case `billing`:
                  case `payment-history`:
                    return null;
                  // no default
                }
              }
              return item;
            })
            .map((item) => {
              const { id, href, title, iconName } = item;
              return (
                <li key={id}>
                  <a href={href} className={linkClass}>
                    <IconWithText name={iconName} size="m">{title}</IconWithText>
                  </a>
                </li>
              );
            })
          }
        </ul>
      </div>

      <div className="m-b-3 p-x-3">
        <h2 className="like-p fw-medium text-uppercase letter-spacing-s color-grey">Help &amp; Logout</h2>
        <ul className="faux-list-new">
          <li>
            <a href="https://www.thecoachingmanual.com/help-centre" target="_blank" rel="noopener noreferrer" className={linkClass}>
              <IconWithText name="outline-help" size="m">Help</IconWithText>
            </a>
          </li>
          <li>
            <a href="mailto:info@thecoachingmanual.com?subject=Email from account menu" className={linkClass}>
              <IconWithText name="outline-email" size="m">Email Us</IconWithText>
            </a>
          </li>
          <li>
            <a href="/auth/logout" className={linkClass}>
              <IconWithText name="outline-logout" size="m">Logout</IconWithText>
            </a>
          </li>
        </ul>
      </div>
    </div>
  );
};

AccountMenu.propTypes = {
  loggedInUser: PropTypes.object.isRequired,
  billingEnabled: PropTypes.bool,
};

export default AccountMenu;



// WEBPACK FOOTER //
// ./library/app/components/Global/Menus/AccountMenu.js